module.exports = __webpack_public_path__ + "img/116.f813e56b.png";